"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var increment = function (x) { return x + 1; };
/**
 * Hook that provides a callback that forces any component using it to re-render.
 */
function useForceUpdate() {
    var _a = __read(React.useState(0), 2), setState = _a[1];
    var forceUpdate = React.useCallback(function () {
        setState(increment);
    }, []);
    return { forceUpdate: forceUpdate };
}
exports.default = useForceUpdate;
//# sourceMappingURL=useForceUpdate.js.map